import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

type DefaultImagesActionsProps = {
  handleSubmit(): void;
};

const DefaultImagesActions: React.FC<DefaultImagesActionsProps> = ({ handleSubmit }) => {
  return (
    <>
      <Tooltip title="Salvar">
        <IconButton color="inherit" onClick={handleSubmit}>
          <DoneIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default DefaultImagesActions;
